import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import RoleGuard from 'utils/route-guard/RoleGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const EncerarDatabaseView = Loadable(lazy(() => import('views/user/DatabaseOperationsView/EncerarDatabaseView')));
const RespaldoBaseDatosView = Loadable(lazy(() => import('views/user/DatabaseOperationsView/RespaldoBaseDatosView')));


const MigrationInventariosView = Loadable(lazy(() => import('views/administrator/MigrationsView/MigrationInventariosView')));

const MigrationCuentasPorPagarProveedoresView = Loadable(lazy(() => import('views/administrator/MigrationsView/MigrationCuentasPagarProveedoresView')));

const MigrationCuentasPorCobrarClientesView = Loadable(lazy(() => import('views/administrator/MigrationsView/MigrationCuentasCobrarClientes')));

const MigrationEstadoSituacionInicialView = Loadable(lazy(() => import('views/administrator/MigrationsView/MigrationEstadoSituacionInicial')));

const ZonasView = Loadable(lazy(() => import('views/user/ZonasView/index')));
const MedidasView = Loadable(lazy(() => import('../views/user/ZonasView/MedidasView/index')));

const SuperAdminCompanyGuard = ({ children }) => (
    <RoleGuard allowedRoles={['Administrador']} requireSuper>
        {children}
    </RoleGuard>
);

const CompanyAdminGuard = ({ children }) => (
    <RoleGuard allowedRoles={['Administrador']} forbidSuper>
        {children}
    </RoleGuard>
);

const DatabasesRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/encerar-database',
            element: (
                <SuperAdminCompanyGuard>
                    <EncerarDatabaseView />
                </SuperAdminCompanyGuard>
            )
        },
        {
            path: '/user/migration-database-inventarios',
            element: (
                <SuperAdminCompanyGuard>
                    <MigrationInventariosView />
                </SuperAdminCompanyGuard>
            )
        },
        {
            path: '/user/migration-database-cuentas-pagar-proveedores',
            element: (
                <SuperAdminCompanyGuard>
                    <MigrationCuentasPorPagarProveedoresView />
                </SuperAdminCompanyGuard>
            )
        },
        {
            path: '/user/migration-database-cuentas-cobrar-clientes',
            element: (
                <SuperAdminCompanyGuard>
                    <MigrationCuentasPorCobrarClientesView />
                </SuperAdminCompanyGuard>
            )
        },
        {
            path: '/user/migration-database-estado-situacion-inicial',
            element: (
                <SuperAdminCompanyGuard>
                    <MigrationEstadoSituacionInicialView />
                </SuperAdminCompanyGuard>
            )
        },
        {
            path: '/user/respaldo-base-datos',
            element: (
                <CompanyAdminGuard>
                    <RespaldoBaseDatosView />
                </CompanyAdminGuard>
            )
        },
        {
            path: '/user/zonas',
            element: <ZonasView />
        },
        {
            path: '/user/zonas-medidas',
            element: <MedidasView />
        }
    ]
};

export default DatabasesRoutes;